import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OAuthResourceServerErrorHandler,
  OAuthStorage,
} from 'angular-oauth2-oidc';
import { catchError, Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiInterceptorService implements HttpInterceptor {
  constructor(
    private authStorage: OAuthStorage,
    private errorHandler: OAuthResourceServerErrorHandler,
    private authService: AuthService
  ) { }

  private checkUrl(url: string): boolean {
    return url.includes(environment.restHost);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.checkUrl(req.url)) return next.handle(req);

    let token = this.authStorage.getItem('access_token');
    let header = 'Bearer ' + token;
    let headers = req.headers.set('Authorization', header);
    req = req.clone({ headers });
    return next.handle(req).pipe(
      catchError((err) => {
        if (
          err.error === 'invalid_grant' ||
          err.error.status === 'UNAUTHORIZED'
        ) {
          this.authService.logout();
        }
        return this.errorHandler.handleError(err);
      })
    );
  }
}
